<!--  -->
<template>
    <el-dialog title="提示" class="deleteClassify" :visible.sync="dialogVisible" width="390px">
        <div class="content">
            <p class="red_text">确认删除该分类吗？</p>
            <p class="black_text">该分类删除后其所属的资讯转移到：</p>
            <el-select v-model="zinnerid" placeholder="请选择分类">
                <el-option v-for="item in classifyList" :key="item.value" :label="item.name" :value="item.innerid"></el-option>
            </el-select>
            <div class="tips">如不选择，该分类下的资讯将不在前端展示。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">退出</el-button>
            <el-button type="primary" @click="deleteSxytopiccolumninfo">确认</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {getSxytopiccolumninfo, deleteSxytopiccolumninfo} from 'api/imageText'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            dialogVisible: false,
            classifyList: [],
            zinnerid: '',
            innerid: ''
        }
    },
    props: ['currenttop'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open(innerid) {
            this.innerid = innerid
            this.getSxytopiccolumninfo()
            // this.dialogVisible = true
        },
        getSxytopiccolumninfo() {
            this.setLoading(true)
            getSxytopiccolumninfo({
                data: {topiccode: this.currenttop.topiccode},
                success: res => {
                    this.setLoading(false)
                    this.dialogVisible = true
                    res.data.content.some((item, index) => {
                        if (item.innerid === this.innerid) {
                            res.data.content.splice(index, 1)
                            return
                        }
                    })
                    res.data.content.unshift({innerid: ' ', name: '不转移到其它分类'})
                    this.classifyList = res.data.content
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        deleteSxytopiccolumninfo() {
            this.setLoading(true)
            deleteSxytopiccolumninfo({
                data: {zinnerid: this.zinnerid === ' ' ? '' : this.zinnerid, innerid: this.innerid},
                success: res => {
                    this.setLoading(false)
                    this.dialogVisible = false
                    this.$emit('deleteSuccess')
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .deleteClassify {
        .content {
            .red_text {
                color: #EC5E69;
            }
            .black_text {
                color: #303133;
            }
            p {
                font-size: 14px;
                margin-bottom: 10px;
            }
            .el-select {
                width: 350px;
                margin-bottom: 6px;
                .el-input__icon {
                    line-height: 32px;
                }
            }
            .tips {
                font-size: 12px;
                color: #999999;
            }
        }
        .el-dialog__footer {
            .el-button {
                margin-bottom: 0;
                &.el-button--primary {
                    margin-left: 20px;
                }
            }
        }
    }
</style>